export const DateReviver = <T extends Record<string, any>>(keys: (keyof T)[]) => {
  const keySet = new Set(keys) as Set<string>;

  return {
    reviver: (k: string, v: unknown) => {
      if (keySet.has(k) && typeof v === 'string') return new Date(v);
      return v;
    },
    replacer: (k: string, v: unknown) => {
      if (keySet.has(k) && v instanceof Date) return v.toISOString();

      return v;
    },
  };
};

export class StorageItem {
  constructor(
    private name: string,
    private storage = localStorage
  ) {}

  set(value: string) {
    console.debug('Setting storage ', this.name, value);
    return this.storage.setItem(this.name, value);
  }

  get(): string | null {
    return this.storage.getItem(this.name);
  }

  delete() {
    console.debug('Removing storage ', this.name);
    this.storage.removeItem(this.name);
  }
}

// Provide references to commonly used localstorage items
export const TokenAdmin = new StorageItem('tokenAdmin');
export const TokenMonitoring = new StorageItem('token');
export const TenantId = new StorageItem('tenantId');
export const TenantDomain = new StorageItem('tenantDomain');
export const AuthStorage = new StorageItem('auth-storage');